module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-main-content"
  }, [_c('div', {
    staticClass: "block-main-ajax block-main-ajax-live"
  }, [(_vm.showDate) ? _c('p', [_vm._v(_vm._s(_vm.dateTitle))]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "block-main-title-small"
  }, [_vm._v(_vm._s(_vm.mainTitle))]), _vm._v(" "), (_vm.showMainUrl) ? _c('top-text-box-main-url') : _vm._e(), _vm._v(" "), (_vm.showMeetingAttendees) ? _c('top-text-box-government-attendees') : _vm._e(), _vm._v(" "), (_vm.showMainText) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.mainText)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHearingLingerText) ? _c('p', [_vm._v(_vm._s(_vm.hearingLingerText))]) : _vm._e(), _vm._v(" "), (_vm.showLinkList) ? _c('top-text-box-link-list') : _vm._e()], 1), _vm._v(" "), _c('top-text-box-bottom-buttons')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63edaf51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top/TopTextBox.vue
// module id = 101
// module chunks = 1